/**
 * @file  src\components\Inventory\CreateInventory\InventorySuccessModal.js
 * @brief  This file is responsible for  inventory creation success popup
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import FireWorkImgTop from "../../../images/party-popper.png";

const InventorySuccessModal = (props) => {
  const {
    onHide,
    showStrengthenSuccessModal,
    successPopUpTitle,
    successPopUpDesc,
  } = props;
  const isClosePopUp = true;
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-custom-width"
      backdrop="static"
    >
      <Modal.Body className="pt-100 pb-32">
        <div className="fireworks-overlay-top">
          <div className="pyro pyro-left-top">
            <div className="before"></div>
            <div className="after"></div>
          </div>
          <img
            className="mw-48"
            src={FireWorkImgTop}
            alt={FireWorkImgTop}
            width={"48px"}
            height={"48px"}
          />
        </div>

        {showStrengthenSuccessModal && (
          <button
            type="button"
            className="btn-close"
            onClick={() => onHide(isClosePopUp)}
          ></button>
        )}

        <h3 className="text-center mt-0">{successPopUpTitle}</h3>

        <Row>
          <Col xl={12} className="">
            <p className=" mb-4 f-size-16 text-center">{successPopUpDesc}</p>
          </Col>
          <Col xl={12} className="">
            <div className="modal-btn-wrap">
              <Button
                variant="primary"
                className="btn w-100"
                onClick={() =>
                  onHide(showStrengthenSuccessModal ? "" : isClosePopUp)
                } // Parameter user to check close popup or redirect to inventory lisiting page.
              >
                {showStrengthenSuccessModal ? "View Listing-Feed" : "Continue"}
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default InventorySuccessModal;
